module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/xheada5-d382066e2a8faa4c272678085ee857c9.jpg";